"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ReselectAcct;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReselectAccount = require("./ReselectAccount.styles");
var _constants = require("../../constants");
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */

function ReselectAcct(_ref) {
  var labelText = _ref.labelText,
    anchorText = _ref.anchorText,
    onChangeBank = _ref.onChangeBank;
  var classes = (0, _ReselectAccount.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-testid": "reselect-account-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "reselect-account-text"
  }, labelText), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "reselect-account-anchor",
    onClick: function onClick(event) {
      event.preventDefault();
      onChangeBank(event);
    },
    title: anchorText
  }, anchorText)));
}
ReselectAcct.propTypes = {
  onChangeBank: _propTypes.func.isRequired,
  labelText: _propTypes.string,
  anchorText: _propTypes.string
};
ReselectAcct.defaultProps = {
  labelText: _constants.RESELECT_DIFFERENT_BANK_LABEL,
  anchorText: _constants.RESELECT_DIFFERENT_BANK_ANCHOR
};
